import React from 'react';
import { formatDateCa } from '../legal-board/legalBoardUi';
import { describeRow, nextObligation, rowTitle } from './calendarCopy';

/**
 * The year's deadlines on a line with a dot each (red past, green done, blue
 * the next one). The whole row opens the screen of that deadline.
 */
function PublicUtilityCalendar({ obligations, donorTotals, today, onOpen }) {
    const next = nextObligation(obligations);
    return (
        <>
            <div className="public-utility-calendar-head">
                <h3>Calendari</h3>
                <span className="legal-board-muted legal-board-small">Avui, {formatDateCa(today)}</span>
            </div>
            <ol className="public-utility-rail" aria-label="Calendari">
                {obligations.map((item) => {
                    const row = describeRow(item, { next, donorTotals, today });
                    const title = rowTitle(item);
                    return (
                        <li key={`${item.key}-${item.fiscalYear}`} className={`public-utility-rail-item ${row.dot}`}>
                            <button type="button" className="public-utility-rail-row" onClick={() => onOpen(item)} aria-label={`${title}. ${row.lead ? `${row.lead} ` : ''}${row.line}`}>
                                <span className="public-utility-rail-date">{formatDateCa(item.deadline)}</span>
                                <span className="public-utility-rail-dot" aria-hidden="true"><i></i></span>
                                <span className="public-utility-rail-text">
                                    <strong>{title}</strong>
                                    <span className={`public-utility-rail-line ${row.tone}`}>
                                        {row.lead ? <span className="public-utility-late">{row.lead} </span> : null}
                                        {row.line}
                                    </span>
                                </span>
                                <i className="fas fa-chevron-right public-utility-rail-chevron" aria-hidden="true"></i>
                            </button>
                        </li>
                    );
                })}
            </ol>
        </>
    );
}

export default PublicUtilityCalendar;
